export default "__VITE_ASSET__4fbca121__"